import * as React from 'react';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
// custom
import LoginView from '../views/login/Login.view';
// admin
import AdminView from '../views/admin/Admin.view';
import EventCreateAdmin from '../views/admin/events/create/Event.create.admin';
import EventsView from '../views/admin/events/Events.admin';
import EventUpdateAdmin from '../views/admin/events/update/Event.update.admin';
import EventPreviewAdmin from '../views/admin/events/view/Event.preview.admin';
import PaymentCreateAdmin from '../views/admin/payments/create/Payment.create.admin';
import PaymentsView from '../views/admin/payments/Payment.admin';
import PaymentUpdateAdmin from '../views/admin/payments/update/Payment.update.admin';
import PromotionCreateAdmin from '../views/admin/promotions/create/Promotion.create.admin';
import PromotionsView from '../views/admin/promotions/Promotions.admin';
import PromotionUpdateAdmin from '../views/admin/promotions/update/Promotion.update.admin';
import SubscriptionView from '../views/admin/subscriptions/Subscription.view';
import SubscriptionUpdateAdminView from '../views/admin/subscriptions/update/Subscription.update';
// user
import UserContactView from '../views/user/contact/User.contact.view';
import UserEventView from '../views/user/events/User.event.view';
import UserProfileView from '../views/user/profile/User.profile.view';
import OnlineRegisterView from '../views/user/register/Online.register.view';
import UserView from '../views/user/User.view';
// stripe payment result pages
import PaymentSuccessView from '../views/payment/results/Payment.success.view';
import PaymentFailureView from '../views/payment/results/Payment.failure.view';
import OfflineRegisterView from '../views/user/register/Offline.register.view';
import OfflineRegistrationSuccess from '../views/user/register/Offline.success.view';



const RouterApp: React.FC = () => (
    <Router>
        <Switch>
            {/* Payments */}
            <Route path="/admin/payments/update" component={PaymentUpdateAdmin}/>
            <Route path="/admin/payments/create" component={PaymentCreateAdmin}/>
            <Route path="/admin/payments" component={PaymentsView}/>
            {/* Promotions */}
            <Route path="/admin/promotions/update" component={PromotionUpdateAdmin}/>
            <Route path="/admin/promotions/create" component={PromotionCreateAdmin}/>
            <Route path="/admin/promotions" component={PromotionsView}/>
            {/* Events */}
            <Route path="/admin/events/update" component={EventUpdateAdmin}/>
            <Route path="/admin/events/create" component={EventCreateAdmin}/>
            <Route path="/admin/events/preview" component={EventPreviewAdmin}/>
            <Route path="/admin/events" component={EventsView}/>
            {/* Subscriptions */}
            <Route path="/admin/subscriptions/:id" component={SubscriptionUpdateAdminView}/>
            <Route path="/admin/subscriptions" component={SubscriptionView}/>
            <Route path="/admin" component={AdminView} />
            {/* User */}            
            <Route path="/profile/details" component={UserProfileView} />
            <Route path="/profile/events" component={UserEventView} />            
            <Route path="/profile/online" component={OnlineRegisterView} />
            <Route path="/profile/offline" component={OfflineRegisterView} />
            <Route path="/profile/contact" component={UserContactView} />
            <Route path="/profile" component={UserView} />
            <Route path="/offline_success" component={OfflineRegistrationSuccess}/>
            <Route path="/payment_success" component={PaymentSuccessView}/>
            <Route path="/payment_failure" component={PaymentFailureView}/>
            <Route path="/" component={LoginView} />
        </Switch>
    </Router>
);

export default RouterApp;